// Flow types automatically removed

import { Component } from 'react';
import { LocalQueryRenderer } from 'react-relay/legacy';
import { designerDirectoryRootQuery as query } from './designerDirectoryRootQuery';
import { DesignerDirectoryWrapper } from './DesignerDirectoryWrapper';
import { getResultsCountForPage, getOffsetForPage } from './helpers/paginationValues';
export class DesignerDirectoryRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialQueryParams: props.queryParams,
        };
    }

    render() {
        const { environment, queryParams, onQueryParamsChange } = this.props;
        const { initialQueryParams } = this.state;
        return (
            <LocalQueryRenderer
                environment={environment}
                query={query}
                fetchPolicy="store-or-network"
                variables={{
                    resultsPerPage: getResultsCountForPage(initialQueryParams.page),
                    pageStartOffset: getOffsetForPage(initialQueryParams.page),
                    search: '',
                    hasSearch: false,
                    hasLocationSearch: false,
                    page: initialQueryParams.page,
                    sortBy: initialQueryParams.sortBy,
                    regionCodes: initialQueryParams.locationFilter,
                    showOnlyTpnFirms: initialQueryParams.showOnlyTpnFirms,
                    showTestFirms: initialQueryParams.showTestFirms,
                }}
                render={({ error, props: relayProps }) => {
                    const containerProps = relayProps || {
                        viewer: null,
                    };
                    return (
                        <DesignerDirectoryWrapper
                            {...queryParams}
                            {...containerProps}
                            initialLoading={!error && !relayProps}
                            initialError={error}
                            onQueryParamsChange={onQueryParamsChange}
                        />
                    );
                }}
            />
        );
    }
}
